import { useQueryContext } from './chunk-DVP3QZCO.mjs';
import { __async, __spreadProps, __spreadValues } from './chunk-YUBKM3FG.mjs';
import { useQuery } from '@tanstack/react-query';
import request from 'graphql-request';

var useRequest = (props) => {
  const { queryKey, getAccessToken, document, variables, staleTime = 5 * 60 * 1e3, enabled = true } = props;
  const { hasuraUrl } = useQueryContext();
  return useQuery({
    queryKey,
    queryFn: () => __async(void 0, null, function* () {
      let headers = {
        "content-type": "application/json"
      };
      if (typeof getAccessToken !== "undefined") {
        try {
          const token = yield getAccessToken();
          if (!token) {
            throw new Error("Invalid access token");
          }
          headers = __spreadProps(__spreadValues({}, headers), {
            Authorization: `Bearer ${token}`
          });
        } catch (error) {
          console.error("Authentication failed:", error);
          throw error;
        }
      }
      try {
        return request({
          url: hasuraUrl,
          document: document.toString(),
          requestHeaders: headers,
          variables
        });
      } catch (error) {
        console.error("GraphQL request failed:", error);
        throw error;
      }
    }),
    staleTime,
    enabled
  });
};

export { useRequest };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-XVMGU2BE.mjs.map